import toast from 'react-hot-toast';

export const notify = (success, message) => {
    const toastOptions = {
        position: 'top-right',
        style: {
            fontSize: '0.75rem',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            lineHeight: 1.5,
        },
        // Prevent duplicate toasts
        id: message, // Use message as unique ID to prevent duplicates
    };

    return success
        ? toast.success(`Başarılı Ekleme/Düzenleme ${message}`, toastOptions)
        : toast.error(`Başarısız Ekleme/Düzenleme ${message}`, toastOptions);
};
